import { DateTime, DurationUnits } from 'luxon'
import { useTranslation } from 'react-i18next'

interface DateTimeSince {
  timeSince: string
  medDate: string
  time: string
}

export const useTimeSinceNow = (dateTimeString: string): DateTimeSince => {
  const { t } = useTranslation()

  if (!dateTimeString) {
    return { timeSince: null, medDate: null, time: null }
  }

  const dateTime = DateTime.fromISO(dateTimeString, { zone: 'utc' })
  const medDate = dateTime.toLocaleString(DateTime.DATE_MED)
  const time = dateTime.toLocaleString(DateTime.TIME_24_SIMPLE)

  const diff = DateTime.now().diff(dateTime, ['years', 'minutes', 'hours', 'days', 'months'])

  const displayUnits: DurationUnits = []

  if (diff.years > 0) {
    displayUnits.push('years')
  } else if (diff.months > 0) {
    displayUnits.push('months')
  } else if (diff.days > 0) {
    displayUnits.push('days')
  } else if (diff.hours > 0) {
    displayUnits.push('hours')
  } else {
    displayUnits.push('minutes')
  }

  const readable = DateTime.now().diff(dateTime, displayUnits).toHuman({ maximumFractionDigits: 0 })

  return {
    timeSince: `${readable} ${t('timeSince.ago', 'ago')}`,
    medDate,
    time,
  }
}
